module.exports = __webpack_public_path__ + "static/img/jju.0a88573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/jju.png
// module id = j+LG
// module chunks = 0